import loadable from '@loadable/component';

const ProjectsPage = loadable(() => import('./page'));
const ProjectDashboardPage = loadable(() => import('./[id]/page'));

export const routes = [
  {
    path: '',
    element: <ProjectsPage />,
  },
  {
    path: ':id',
    element: <ProjectDashboardPage />,
  },
];
